import { useState, lazy, Suspense } from "react";
import { Tabs, Tab, Box, CircularProgress, Divider } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";

/* lazy-load to avoid loading all charts at once */
import OverviewDashboard from "./OverviewDashboard";
import UsersDashboard from "./UsersDashboard";
import CoursesDashboard from "./CoursesDashboard";
import ClickstreamDashboard from "./ClickStreamDashboard";

function TabPanel({ value, index, children }) {
  return (
    <div role="tabpanel" hidden={value !== index} style={{ width: "100%" }}>
      {value === index && <Box pt={2}>{children}</Box>}
    </div>
  );
}

export default function AnalyticsDashboard() {
  const [tab, setTab] = useState(0);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDTypography variant="h3" mt={2}>Analytics</MDTypography>
      <Divider />
    <Box width="100%">
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        allowScrollButtonsMobile
      >
        {/* <Tab label="Overview" /> */}
        <Tab label="Users" />
        <Tab label="Courses" />
        <Tab label="Events" />
      </Tabs>

      <Suspense fallback={<Box py={6} display="flex" justifyContent="center"><CircularProgress /></Box>}>
        {/* <TabPanel value={tab} index={0}><OverviewDashboard /> </TabPanel> */}
        <TabPanel value={tab} index={0}><UsersDashboard /> </TabPanel>
        <TabPanel value={tab} index={1}><CoursesDashboard /> </TabPanel>
        <TabPanel value={tab} index={2}><ClickstreamDashboard /> </TabPanel>
      </Suspense>
    </Box>
    </DashboardLayout>
  );
}
